import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchCategoryTreeData from '../Services/fetchCategoryTreeData';

export default function useCategoryTreeQuery() {
	const { accessToken } = useAuth();

	const categoryTreeQuery = useQuery({
		queryKey: ['categoryTree'],
		queryFn: () => fetchCategoryTreeData({ accessToken }),

		staleTime: Infinity,
		retry: false,
	});

	return categoryTreeQuery;
}
